import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EmailNotReceivedDisclaimer } from "../card/footer/email-not-reveived.js";
import { HelpText } from "../card/footer/help-text.js";
import { OAuthContactSupport } from "../card/footer/oauth-contact-support.js";
import { ProtectedBy } from "../card/footer/protected-by.js";
import { RegistrationDisclaimer } from "../card/footer/registration-disclaimer.js";
const RenderFooterText = ({ authStep }) => {
    switch (authStep.type) {
        case "initial":
            return _jsx(RegistrationDisclaimer, {});
        case "email_verify":
        case "otp_verify":
            return _jsx(EmailNotReceivedDisclaimer, { authStep: authStep });
        case "passkey_create":
        case "wallet_connect":
        case "passkey_verify":
            return _jsx(HelpText, {});
        case "oauth_completing":
            return _jsx(OAuthContactSupport, {});
        case "email_completing":
        case "passkey_create_success":
        case "eoa_connect":
        case "pick_eoa":
        case "complete":
            return null;
    }
};
export const Footer = ({ authStep }) => {
    return (_jsxs("div", { className: "p-5 pt-2", children: [_jsx(RenderFooterText, { authStep: authStep }), _jsx("div", { className: "flex justify-center", children: _jsx(ProtectedBy, {}) })] }));
};
//# sourceMappingURL=Footer.js.map